import styled from 'styled-components';
import SearchIcon from '~/assets/svgs/search.svg';
import HamburgerIcon from '~/assets/svgs/hamburger.svg';
import { useContainerContext } from '~/components/container';

const Header = () => {
  const { setSidebarOpen } = useContainerContext();
  return (
    <S.Header>
      <S.SidebarButton onClick={() => setSidebarOpen((p) => !p)}>
        <S.HamburgerIcon />
      </S.SidebarButton>
      <S.SearchContainer>
        <S.SearchIcon width="16" height="16" />
        <S.SearchInput placeholder="Search" />
      </S.SearchContainer>
    </S.Header>
  );
};

const S = {
  Header: styled.section`
    background: #fff;
    height: var(--header-height);
    display: flex;
    align-items: center;

    @media (min-width: ${({ theme }) => theme.screens.md}) {
      padding-left: calc(var(--sidebar-width) + 1rem);
    }
  `,
  SidebarButton: styled.button`
    background: none;
    border: none;

    @media (min-width: ${({ theme }) => theme.screens.md}) {
      display: none;
    }
  `,
  HamburgerIcon: styled(HamburgerIcon)`
    width: 36px;
    height: 36px;
    cursor: pointer;

    &:hover {
      opacity: 0.6;
    }
  `,
  SearchContainer: styled.div`
    position: relative;
    max-width: 356px;
    width: 100%;
  `,
  SearchIcon: styled(SearchIcon)`
    position: absolute;
    left: 0.75rem;
    top: 0.65rem;
  `,
  SearchInput: styled.input`
    background: #f5f6fa;
    border: 0.6px solid #d5d5d5;
    border-radius: 19px;
    padding: 0.65rem 1.25rem 0.65rem 2.5rem;
    color: #202224;
    display: inline-block;
    letter-spacing: -0.2px;
    width: 100%;

    &:focus {
      border-color: ${({ theme }) => theme.colors.primary};
      outline-color: ${({ theme }) => theme.colors.primary};
      background: #fff;
    }
  `,
};

export default Header;
